import { platformStats } from '@/mocks/sports';

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            平台实力
          </h2>
          <p className="text-sm text-foreground-500 mt-2">数据见证我们的成长与信赖</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {platformStats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-100 rounded-lg p-6 md:p-8 text-center border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-50 flex items-center justify-center text-accent-500">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-1">{stat.value}</div>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}